function customProduct(){
    $('.product').each(function() {
        var product = $(this);
        if($(this).find('.ratings-wrapper').length){
            $(this).find('.p-bottom>div').append($(this).find('.ratings-wrapper'))
        }
        if($(this).find('.flag-discount').length){
            $(this).find('.prices').prepend($(this).find('.price-standard'))
            $(this).find('.prices').append($(this).find('.price-save'))
        }
        $(this).find('.p').append('<span class="btn_toggle"></span>');
        if($(this).find('.p-desc').length<1){
            $(this).find('.p-bottom>div').append('<p class="p-desc" data-micro="description" data-testid="productCardShortDescr"></p>')
        }
        
        const availabilityText = $(this).find('.availability span').text().trim();
        if (availabilityMap[availabilityText]) {
            let hours = availabilityMap[availabilityText];
            const deliveryDate = calculateDeliveryDate(hours);
            const formattedDate =  formatDate(deliveryDate);
            if(typeof $(this).find('.availability span').attr('style') == 'undefined'){
              var bgColor = 'color:#000';
            }
            else{
              var bgColor = $(this).find('.availability span').attr('style')
            }
            $(this).find('.availability span').append('<span class="question" style="background-'+bgColor+'">?</span>').addClass('show-tooltip').attr('title', 'Můžeme doručit do '+formattedDate).attr('data-title', 'Můžeme doručit do '+formattedDate)
        }
    });
    initTooltips();
}
    

$(document).ready(function(){
    customProduct();
});
    
document.addEventListener('ShoptetDOMPageContentLoaded', function() {
    customProduct();
});
document.addEventListener('ShoptetPageSortingChanged', function() {
    customProduct();
});
document.addEventListener('ShoptetDOMPageMoreProductsLoaded', function() {
    customProduct();
});

const fixedHolidays = [
    '01-01', // Nový rok
    '05-01', // Svátek práce
    '05-08', // Den vítězství
    '07-05', // Cyril a Metoděj
    '07-06', // Jan Hus
    '09-28', // Den české státnosti
    '10-28', // Den vzniku Československa
    '11-17', // Den boje za svobodu a demokracii
    '12-24', // Štědrý den
    '12-25', // 1. svátek vánoční
    '12-26'  // 2. svátek vánoční
  ];

  function formatDate(date) {
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}.${month}.${year}`;
  }

  function getEasterMonday(year) {
    const f = Math.floor,
          G = year % 19,
          C = f(year / 100),
          H = (C - f(C / 4) - f((8 * C + 13) / 25) + 19 * G + 15) % 30,
          I = H - f(H / 28) * (1 - f(29 / (H + 1)) * f((21 - G) / 11)),
          J = (year + f(year / 4) + I + 2 - C + f(C / 4)) % 7,
          L = I - J,
          month = 3 + f((L + 40) / 44),
          day = L + 28 - 31 * f(month / 4);
    const easterSunday = new Date(year, month - 1, day);
    const easterMonday = new Date(easterSunday);
    easterMonday.setDate(easterMonday.getDate() + 1);
    
    return easterMonday;
  }

  function getGoodFriday(year) {
    const easterMonday = getEasterMonday(year);
    const goodFriday = new Date(easterMonday);
    goodFriday.setDate(easterMonday.getDate() - 3);
    return goodFriday;
  }

  function isHolidayOrWeekend(date) {
    const dayOfWeek = date.getDay();
    const formattedDate = date.toISOString().split('T')[0];
    const year = date.getFullYear();
    const isFixedHoliday = fixedHolidays.includes(formattedDate.slice(5));
    const easterMonday = getEasterMonday(year);
    const goodFriday = getGoodFriday(year);
    const isEasterMonday = (formattedDate === easterMonday.toISOString().split('T')[0]);
    const isGoodFriday = (formattedDate === goodFriday.toISOString().split('T')[0]);
    return (dayOfWeek === 0 || dayOfWeek === 6 || isFixedHoliday || isEasterMonday || isGoodFriday);
  }

  function calculateDeliveryDate(hoursToAdd) {
    let currentDate = new Date();
    let hoursAdded = 0;
    const currentHour = currentDate.getHours();
    const currentMinutes = currentDate.getMinutes();
    if (currentHour > 14 || (currentHour === 14 && currentMinutes > 30)) {
      hoursToAdd += 24;
    }
    while (hoursAdded < hoursToAdd) {
      currentDate.setHours(currentDate.getHours() + 1);
      if (!isHolidayOrWeekend(currentDate)) {
        hoursAdded++;
      }
    }
    return currentDate;
  }